import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { setCredentialEffect } from '../_effects';
import { alertActions } from './alertActions';

export const setCredentialActions = {
  setCredintial,
};

function setCredintial(credential) {
  return (dispatch) => {
    dispatch(request(credential));
    setCredentialEffect.setCredential(credential).then(
      (credential) => {
        dispatch(success(credential));
        if (credential.data.statusCode === '202' || credential.data.statusCode === '203' || credential.data.statusCode === '403') {
          history.push('/set-credentials');
        } else {
          history.push('/set-credentials');
        }
        // if (credential.data.statusCode === '200') {
        //   history.push('/');
        // } else if (credential.data.statusCode === '202') {
        //   history.push('/set-credentials');
        // } else if (credential.data.statusCode === '203') {
        //   history.push('/set-credentials');
        // } else if (credential.data.statusCode === '201') {
        //   history.push('/');
        // } else if (credential.data.statusCode === '403') {
        //   history.push('/set-credentials');
        // } else {
        //   history.push('/set-credentials');
        // }
      },
      (error) => {
        console.log('action reset error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(credential) {
    return { type: userConstants.SETCREDENTAIL_REQUEST, credential };
  }
  function success(credential) {
    return { type: userConstants.SETCREDENTAIL_SUCCESS, credential };
  }
  function failure(error) {
    return { type: userConstants.SETCREDENTAIL_FAILURE, error };
  }
}
